if (!customElements.get('feature-list')) {
  customElements.define('feature-list', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._viewport = this.querySelector('[data-feature-list-viewport]');
      this._grid = this.querySelector('[data-feature-list-grid]');
      this._progress = this.querySelector('[data-feature-list-progress]');
      this._progressWrapper = this.querySelector('[data-feature-list-progress-wrapper]');
      if (!this._viewport || !this._grid || !this._progress || !this._progressWrapper) return;

      this._controller = new AbortController();
      const options = { signal: this._controller.signal };
      // Reuse the theme's scrollable-content event and progress-bar CSS.
      this._viewport.addEventListener('scrollable-content:progress', (event) => {
        this._setProgress(event.detail.progress);
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('[data-feature-list-item]');
        if (item && this.contains(item)) item.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      }, options);
      if ('ResizeObserver' in window) {
        this._observer = new ResizeObserver(() => this._update());
        this._observer.observe(this._viewport);
        this._observer.observe(this._grid);
      } else {
        window.addEventListener('resize', () => this._update(), options);
      }
      this._update();
    }

    _setProgress(value) {
      this._progress.style.setProperty('--transform', `${Number.isFinite(value) ? Math.max(0, Math.min(100, value)) : 0}%`);
    }

    _update() {
      const distance = this._viewport.scrollWidth - this._viewport.clientWidth;
      const scrollable = distance > 1;
      this._progressWrapper.hidden = !scrollable;
      if (scrollable) this._viewport.setAttribute('tabindex', '0');
      else this._viewport.removeAttribute('tabindex');
      // The design uses a 115px indicator; reuse the shared divider/transform contract.
      const width = this._progress.clientWidth;
      this._progress.style.setProperty('--divider', width > 0 ? Math.max(1, width / 115) : 1);
      this._setProgress(scrollable ? Math.abs(this._viewport.scrollLeft) / distance * 100 : 0);
    }

    disconnectedCallback() {
      this._controller?.abort();
      this._observer?.disconnect();
      this._controller = null;
    }
  });
}
